<template>
  <div id="addBanks">
    <div class="container">
      <headNav>
        <div slot="headNavText">{{title}}</div>
      </headNav>
      <div class="banksBox">
        <div class="bascInfoContent" style="margin-top: 0.6rem">
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.holdName')}}</div>
            <van-field v-model="holdBankPer" readonly/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.idcar')}}</div>
            <van-field v-model="holdBankIdCard" readonly/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.bankCard')}}</div>
            <van-field v-model="BankId" :placeholder="$t('message.banksAccount')" type="number"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.bankNwes')}}</div>
            <van-field v-model="bankName" :placeholder="$t('message.choose_banks')" right-icon="arrow-down" @focus="showModel" readonly/>
          </div>
          <div class="form_item" >
            <div class="form_label"><span>*</span>{{$t('message.ver_code')}}</div>
            <div style="position: relative">
              <van-field label="" value="" v-model="code" class="form_border"/>
              <div class="code_btn" @click.prevent="sendCode" :disabled="unavailable" ref="sendCodeBtn">{{buttonText}}</div>
            </div>

          </div>
        </div>
        <van-button block round style="margin-top: 15px" @click="addBank" id="add_bank_btn" :disabled="btnDisabled">{{$t('message.add_com')}}
        </van-button>
      </div>
    </div>
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-picker :columns='banksArr' @change="onChange" @cancel="onCancel" :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {postBanks, postUserInfo, getBanks, sendCode,UserBankSms,UserBankAction} from '../../../ports/port'
  let timer;
  export default {
    name: "addBanks",
    data() {
      return {
        holdBankPer: '',//持卡人姓名
        holdBankIdCard: '',//联系人身份证
        bankName: '',//银行卡名称
        BankId: '',//银行卡卡号
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        banksArr: [],
        bankLogo: [],//存放银行logo
        banksList: [],
        temp: [],
        showTip: false,
        //一下是选择银行卡，所需要向后端提供的
        bankID: '',
        accountSupport: '',
        cardSupport: '',
        abbreviation: '',
        //以上是选择银行卡，所需要向后端提供的
        show: false,
        buttonText: this.$t('message.send_code'),
        unavailable:false,
        code:'',
        userbankID:'',
        type:1,
        title:'',
        btnDisabled:false
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      if(this.$route.query.userBank != undefined){
        this.userBankInfo = JSON.parse(this.$route.query.userBank);
        this.bankName = this.userBankInfo.bank_name;
        this.BankId = this.userBankInfo.bank_card;
        this.type=2;
        this.userbankID = this.userBankInfo.id;
        this.title = this.$t('message.edit_bank');
      }else{
        this.type=1;
        this.userbankID = "";
        this.title = this.$t('message.add_bank');
      }
      postUserInfo({userid: this.tk.userid})
        .then(res => {
          if (res.data.code == 200) {
            this.holdBankPer = res.data.data.truename;
            this.holdBankIdCard = res.data.data.idcard;
          }
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
      //获取银行卡种类
      getBanks({})
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            this.temp = res.data.data;
            arr.forEach((elem, index) => {
              this.bankLogo.push(elem.photo_url);
              this.banksArr.push({'text': `<img class="cloumns-img" src='${this.bankLogo[index]}'>` + elem.abbreviation});
              this.banksList.push(elem.abbreviation);
            })
          }
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        })
    },
    methods: {
      sendCode() {
        //平台、设备和操作系统
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);

        if (system.win || system.mac || system.xll) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.use_phone')//请使用手机登录
          });
        }else{
          //定时器
          if (!this.unavailable) {
            this.unavailable = true;
            let i = 61;
            timer = setInterval(() => {
              i--;
              this.buttonText = i + 'S';
              if (i < 1) {
                clearInterval(timer);
                this.buttonText = this.$t('message.send_code');
                this.unavailable = false;
                this.$refs.sendCodeBtn.style.backgroundColor = this.$color;
              }
            }, 1000);
            this.$refs.sendCodeBtn.style.backgroundColor = '#f5b8e8';

            //发送验证码
            UserBankSms({userid:this.tk.userid})
              .then(res => {
                if (res.data.code == 200) {
                  if((!Array.isArray(res.data.data)) && res.data.data.type==3){
                    this.$notify({type: 'success', message: "Vui lòng mở Zalo kiểm tra mã xác thực"});//请打开zalo查收验证码
                  }else{
                    this.$notify({type: 'success', message: this.$t('message.ver_code_success')});
                  }
                } else{
                  this.$notify({type: 'danger', message: this.$t('message.ver_code_error')});
                }
              })
              .catch(err => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (err.toString().indexOf('timeout') != -1) {
                  this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                }
              })
          }

        }
      },
      //添加银行卡
      addBank() {
        // let data = {
        //   userid: this.tk.userid,
        //   bankCard: this.BankId,
        //   bankID: this.bankID,
        //   accountSupport: this.accountSupport,
        //   cardSupport: this.cardSupport,
        //   abbreviation: this.abbreviation
        // };
        if(this.bankID.trim()=='' || this.code.trim()=='' || this.BankId.trim()==''){
          this.$notify({type: 'danger', message: this.$t('message.jcNEWS')});
          return false
        }
        if(this.code.trim().length<4 || this.code.trim().length>6){
          this.$notify({
            type: 'danger',
            message: this.$t('message.yys_error_code')//请使用手机登录
          });
          return false
        }
        this.btnDisabled = true;
        let data;
        if(this.type==2){
          this.temp.filter((e,i)=>{
            if(e.abbreviation==this.bankName){
              this.bankID = e.bankID;
            }
          });
          data = {userid:this.tk.userid,bankCard:this.BankId,bankID:this.bankID,code:this.code,type:this.type,userbankID:this.userbankID};
        }else{
          data = {userid:this.tk.userid,bankCard:this.BankId,bankID:this.bankID,code:this.code,type:this.type};
        }
        this.$store.commit('edit', true);//关闭全局的loading
        UserBankAction(data)
          .then(res => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (res.data.code == 200) {
              let _this = this;
              // 银行卡审核中，请等待客服电话确认
              this.$notify({type: 'success', message: 'Đang xác minh thẻ ngân hàng, vui lòng chờ  CSKH gọi điện xác nhận',onClose:function(){
                  _this.$router.go(-1);
                  _this.btnDisabled = false;
                }});
            } else{
              this.btnDisabled = false;
              this.$notify({type: 'danger', message: res.data.msg});
            }
          })
          .catch(err => {
            this.btnDisabled = false;
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      showModel(a) {
        this.show = true;
      },
      //选择框滚动时，表单内的值变化
      onChange(picker, value, index) {
        // this.bankName=value;
        this.bankName = this.banksList[index];
      },
      //确定选择的值
      onConfirm(value, index) {
        let abbrev = this.banksList[index];
        this.bankName = this.banksList[index];
        this.temp.forEach((elem, index) => {
          if (elem.abbreviation == abbrev) {
            this.bankID = elem.bankID;
            this.accountSupport = elem.accountSupport;
            this.cardSupport = elem.cardSupport;
            this.abbreviation = elem.abbreviation;
          }
        });
        this.show = false;
      },
      //关闭选择框
      onCancel() {
        this.show = false;
      },
    }
  }
</script>

<style scoped lang="scss">
  #add_bank_btn {
    @include defaultBtn;
    margin: 1.2rem 0 0.2rem;
  }

  /deep/ .van-cell.van-field {
    border-radius: 8px !important;
    border: 1px solid #cccccc !important;
  }

  /deep/ .cloumns-img {
    /*width: 80px!important;*/
    vertical-align: sub;
    margin-right: 10px;
    height: 23px !important;
  }

  .container {
    padding: 55px 15px 0;

    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: #014CCC;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }

    .form_item {
      margin-bottom: 0.36rem;

      .form_label {
        color: #000000;
        font-size: 0.45rem;
        font-weight: 500;
        margin-bottom: 0.27rem;

        span {
          color: #FF0300;
          margin-right: 3px;
        }
      }
    }

    .tips {
      color: #B9B9B9;
      font-size: 0.33rem;
    }
  }
  .code_btn {
    background: $color;
    width: 3.31rem;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.35rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/editInfos/addBanks.vue